import * as Yup from 'yup';
import strings from '../../localization';

const Validator = () =>
  Yup.object().shape({
    email: Yup.string().email().trim().required(strings.requiredField),
  });

export default Validator;
